import { gql } from "@/services/httpAdapter";

const SplitItemFloatFragment = gql`
	fragment SplitItemFloat on WashoutSplitItemFloat {
		retail
		lease
		value
	}
`;

const SplitItemIntFragment = gql`
	fragment SplitItemInt on WashoutSplitItemInt {
		retail
		lease
		value
	}
`;

const SalesWashoutTableItemPVRFragment = gql`
	fragment SalesWashoutTableItemPVR on DepartmentalWashoutTableItem {
		_id
		label
		pvr
		units {
			...SplitItemInt
		}
		contracts {
			...SplitItemFloat
		}
		grossProfit {
			...SplitItemFloat
		}
	}
`;

const SalesWashoutTableItemAccountFragment = gql`
	fragment SalesWashoutTableItemAccount on DepartmentalWashoutTableItem {
		_id
		label
		pvr
		account
		units {
			...SplitItemInt
		}
		contracts {
			...SplitItemFloat
		}
		grossProfit {
			...SplitItemFloat
		}
	}
`;

const SalesWashoutTableItemDisplayFragment = gql`
	fragment SalesWashoutTableItemDisplay on DepartmentalWashoutTableItem {
		_id
		label
		account
		units {
			...SplitItemInt
		}
		contracts {
			...SplitItemFloat
		}
		grossProfit {
			...SplitItemFloat
		}
		pvr
		subFooter
		emptyRow
		isFooter
		icon
		oemRow
		page
		isDefaultPage
		title
		groupId
		subgroupId
	}
`;

const SalesWashoutTableItemFragment = gql`
	fragment SalesWashoutTableItem on DepartmentalWashoutTableItem {
		_id
		label
		account
		units {
			...SplitItemInt
		}
		contracts {
			...SplitItemFloat
		}
		grossProfit {
			...SplitItemFloat
		}
		pvr
		subFooter
		emptyRow
		oemRow
		groupRow
		isFooter
		icon
		page
		isDefaultPage
		title
		groupId
		subgroupId
		display {
			...SalesWashoutTableItemDisplay
		}
	}
`;

const SalesWashoutTableGroupFragment = gql`
	fragment SalesWashoutTableGroup on DepartmentalWashoutTableGroup {
		_id
		group
		values {
			...SalesWashoutTableItemAccount
		}
	}
`;

const NewCarsSalesFranchiseFragment = gql`
	fragment NewCarsSalesFranchise on WashoutNewCarsSalesFranchise {
		_id
		franchise
		franchises
		groups {
			...SalesWashoutTableGroup
		}
		display {
			...SalesWashoutTableItem
		}
		totals {
			...SalesWashoutTableItemPVR
		}
	}
`;

const WashoutNewCarsSalesFragment = gql`
	fragment NewCarsSales on WashoutNewCarsSales {
		_id
		oemReference
		dealerCodeFS
		franchises {
			...NewCarsSalesFranchise
		}
		totals {
			...SalesWashoutTableItemPVR
		}
	}
	${NewCarsSalesFranchiseFragment}
	${SalesWashoutTableGroupFragment}
	${SalesWashoutTableItemFragment}
	${SalesWashoutTableItemAccountFragment}
	${SalesWashoutTableItemDisplayFragment}
	${SalesWashoutTableItemPVRFragment}
	${SplitItemFloatFragment}
	${SplitItemIntFragment}
`;

const WashoutCrossStoreSalesFragment = gql`
	fragment WashoutCrossStoreSales on WashoutSalesPerformance {
		sales {
			_id
			saleDate
			dealNumber
			customerName
			customerNumber
			stockNumber
			description
			saleType
			dealType
			adjustable
			frontGrossProfit
			backGrossProfit
			units
			saleAmount
			vehicleInformation {
				make
				model
				modelYear
				trim
			}
			frontProducts {
				_id
				product
				value
			}
			backProducts {
				_id
				product
				value
			}
			frontCommission
			backCommission
			grossCommission
			funded
			external
			origin {
				icon
				tooltip
			}
			salesEmployeeId
			salesEmployeeName
			financeEmployeeId
			financeEmployeeName
			salesManagerId
			salesManagerName
		}
		totals {
			totalsTypeTitle
			frontGrossProfit
			backGrossProfit
			frontProducts {
				_id
				product
				total
			}
			backProducts {
				_id
				product
				total
			}
			frontCommission
			backCommission
			grossCommission
			units
		}
		cards {
			globalUnitCounts
			financeGlobalUnitCounts
			frontEndPvr {
				new
				preOwned
				total
			}
			backEndPvr {
				new
				preOwned
				total
			}
			productPenetration {
				new
				preOwned
				total
			}
		}
		columnVisibility {
			columnName
			visibility
		}
	}
`;

export { WashoutNewCarsSalesFragment, WashoutCrossStoreSalesFragment };
